<template>
  <div>
        <v-row>
            <v-text-field
                v-model="company.name"
                @input="updateCompany()"
                :label="$t('PopupCreateCompany.company_name')"
                outlined
            />
        </v-row>
        <v-row>
            <v-text-field
                v-model="company.cif"
                @input="updateCompany()"
                :label="$t('PopupCreateCompany.company_cif')"
                outlined
            />
        </v-row>
        <v-row v-for="(field, index) in extra_fields" :key="index">
            <v-text-field
                v-if="company.custom_fields"
                v-model="company.custom_fields[field.value]"
                @input="(value) => updateNested({ key: field.value, value })"
                :label="field.text"
                outlined
            />
        </v-row>
        <!-- <v-row style="padding-top: 15px; justify-content: right;">
            <v-btn @click="cancel()" outlined color="primary" style="margin-right: 20px;">
                {{$t("PopupCreateCompany.cancel")}}
            </v-btn>
            <v-btn @click="updateCompany()" color="primary">
                <div v-if="!is_create">{{$t("PopupCreateCompany.edit")}}</div>
                <div v-else>{{$t("PopupCreateCompany.create")}}</div>
            </v-btn>
        </v-row> -->
    </div>
</template>

<script>
export default {
  name: 'SimpleCompanyEditor',
  
  props:{
    value: {
      type: Object,
      default: () => ({
        id: null,
        name: null,
        cif: null,
        custom_fields: null
      })
    },
    extra_fields: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      company:{}
    };
  },
  methods: {
    updateNested(inp){
        let custom_fields = {...this.company.custom_fields, [inp.key]: inp.value };
        this.company = { ...this.company, custom_fields: custom_fields };
        this.updateCompany();
    },
    updateCompany() {
      this.$emit('input', this.company);
    },
    cancel(){
        // Emit an event to notify that the editing was cancelled
        this.$emit('cancel');
    }
  },
  mounted() {
    // Initialize the company data from the value prop
    this.company = { ...this.value };
    if (!this.company.custom_fields) {
      this.company.custom_fields = {};
    }
  },
}
</script>

<style scoped>
</style>
